export { default as FiltersPanel } from './filtersPanel/FiltersPanel';
